<template>
    <v-card class="question-list">
        <h4 class="question-list-h">{{ $t('question.QuestionList') }}</h4>
        <ul class="clearfix" ref="list">
            <li v-for="(item, i) in pageData" :class="className(item.is_right, item.submitted, (page - 1) * pageSize + i, item.currentSubmitted)"
                @click="switchQuestion((page - 1) * pageSize + i)" :key="i">
                {{ ((page - 1) * pageSize) + i + 1 }}
                <ct-icon class="editing" name="pencil"></ct-icon>
            </li>
        </ul>
        <div style="margin-top: 32px;">
            <v-pagination :total="total" :page="page" @change-page="changePage"></v-pagination>
        </div>
    </v-card>
</template>
<script>
import VCard from '@ca/components/Card'
import Pagination from '@ca/components/Pagination'
import { mapGetters, mapActions, mapState } from 'vuex'
let pageSize = 50

export default {
  name: 'QuestionList',
  components: {
    'v-card': VCard,
    'v-pagination': Pagination
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeIndex: Number
  },
  data () {
    return {
      index: null,
      pageSize: pageSize,
      innerHeight: window.innerHeight
    }
  },
  watch: {
    questionIndex (value) {
      this.switchQuestion(value)
    },
    index (value) {
      this.updateQuestionIndex({
        index: value,
        examId: this.$route.params.exam_id,
        classId: this.$route.params.class_id,
        subclassId: this.$route.params.subclass_id
      })
      this.updateProgress(value)
    }
  },
  computed: {
    ...mapGetters('answer', ['questionIndex', 'questionList', 'examSubmitted']),
    ...mapState('answer', ['questions']),
    dataList () {
      return this.questionList || this.list
    },
    examId () {
      return this.$route.params.exam_id
    },
    parentsPage () {
      return this.$route.path.split('/')[1]
    },
    progressName () {
      return `${this.parentsPage}_progress`
    },
    pageData () {
      const index = (this.page - 1) * this.pageSize
      const end = this.page * this.pageSize
      const list = this.dataList.slice(index, end)
      const storage = JSON.parse(localStorage.getItem('answer_answers') || '{}')
      list.forEach(item => {
        if (storage[item.question_id]) {
          // 当前题目已提交
          item.currentSubmitted = true
        }
      })
      return list
    },
    listLength () {
      return this.dataList.length
    },
    total () {
      return Math.ceil(this.dataList.length / this.pageSize)
    },
    page () {
      return Math.ceil((this.index + 1) / this.pageSize)
    }
  },
  methods: {
    ...mapActions('answer', ['updateQuestionIndex']),
    changePage (page) {
      this.index = (page - 1) * this.pageSize
      this.updateProgress(this.index)
    },
    className (isRight, submitted, i, currentSubmitted) {
      let className = 'default'
      if (submitted && !!isRight) {
        className = className + ' passed'
      }
      if (submitted && !isRight) {
        className = className + ' not-pass'
      }
      if (this.index === i) {
        className = className + ' active'
      }
      if (currentSubmitted && !this.examSubmitted) {
        className = className + ' submitted'
      }
      return className
    },
    prevQuestion () {
      this.switchQuestion(this.index - 1)
    },
    nextQuestion () {
      this.switchQuestion(this.index + 1)
    },
    switchQuestion (index) {
      if (index < 0 || index >= this.listLength) {
        return false
      }
      this.index = index
      this.navigateQuestion()
    },
    navigateQuestion () {
      this.$emit('navigate-question', this.list[this.index].question_id)
    },
    updateProgress (index) {
      const progressName = this.progressName
      const progress = JSON.parse(window.localStorage.getItem(progressName))
      const newProgress = Object.assign({}, progress, {
        [this.examId]: index
      })
      window.localStorage.setItem(progressName, JSON.stringify(newProgress))
    },
    addEvent () {
      if (document.addEventListener) {
        document.addEventListener('keyup', this.handleKeyup)
      }
    },
    removeEvent () {
      if (document.removeEventListener) {
        document.removeEventListener('keyup', this.handleKeyup)
      }
    },
    handleKeyup (event) {
      if (document.body.style.overflow === 'hidden') {
        return false
      }
      const ARROWLEFT = event.key.toUpperCase() === 'ARROWLEFT' || event.keyCode === 37
      const ARROWRIGHT = event.key.toUpperCase() === 'ARROWRIGHT' || event.keyCode === 39
      if (event.shiftKey && ARROWLEFT) {
        this.prevQuestion()
      }
      if (event.shiftKey && ARROWRIGHT) {
        this.nextQuestion()
      }
    },
    initPageSize () {
      if (this.$refs.list) {
        const listOffsetTop = this.$refs.list.offsetTop
        const $footerBar = document.querySelector('.float-block-fixed')
        const listParentTop = $footerBar.offsetTop || 130
        const footerBarHeight = 60
        const lines = (this.innerHeight - listParentTop - listOffsetTop - footerBarHeight - 23 - 40) / 24
        if (Math.floor(lines) < 1) {
          return pageSize
        }
        return Math.min(Math.floor(lines) * 5, pageSize)
      } else {
        return pageSize
      }
    }
  },
  mounted () {
    this.pageSize = this.initPageSize()
    const progress = JSON.parse(window.localStorage.getItem(this.progressName))
    if (this.activeIndex !== null && this.activeIndex >= 0) {
      this.index = this.activeIndex
    } else if (progress) {
      this.index = progress[this.examId] || 0
    } else {
      this.index = 0
    }
    this.addEvent()
  },
  destroyed () {
    this.removeEvent()
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';

.question-list {
    text-align: center;
    padding: 32px 10px 23px;

    &-h {
        margin-bottom: 24px;
        font-family: SFProDisplay-Medium;
        font-weight: 500;
    }
}

.clearfix {
    display: table;
    width: 271px;
    margin: 0 auto;
}

.default {
    cursor: pointer;
    float: left;
    width: 54px;
    font-size: 14px;
    font-family: DINPro-Medium;
    font-weight: 500;
    line-height: 1;
    color: rgba(186, 196, 206, 1);
    padding: 5px 0;

    .editing {
        width: 0;
        font-size: 10px;
        margin-top: 2px;
        overflow: hidden;
        vertical-align: middle;
        position: absolute;
    }

    &.active {
        background-color:  #37cad7cc;
        color: $secondary;
        border-radius: 12px;

        .editing {
            width: auto;
            color: $secondary;
        }
    }

    &.passed {
        color: $success;

        &.active {
            color: $success;
        }
    }

    &.not-pass {
        color: $danger;

        &.active {
            color: $danger;
        }
    }
    &.submitted {
        background-color: #37cad7cc;
        color: $secondary;
        border-radius: 12px;
    }
}</style>
